import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingIndicator = ({ size = 20 }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        zIndex: 1,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingIndicator;